import { render, staticRenderFns } from "./ConfigElocaErp.vue?vue&type=template&id=62fd17fc"
import script from "./ConfigElocaErp.vue?vue&type=script&lang=js"
export * from "./ConfigElocaErp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports